/**
 * Internal dependencies
 */
import './provider';
import './consumer';
//# sourceMappingURL=index.js.map